// angular
import { Component, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
// components
import { FiltersDialogComponent } from '@app/core/components/filters-dialog/filters-dialog.component';
import { SolutionsPeopleFiltersComponent } from '../solutions-people-filters/solutions-people-filters.component';// utils
import { DialogRef } from '@app/core/shared/utils/dialog/dialog-ref';

@Component({
  selector: 'pwj-solutions-people-filters-dialog',
  standalone: true,
  imports: [FiltersDialogComponent, SolutionsPeopleFiltersComponent],
  templateUrl: './solutions-people-filters-dialog.component.html',
})
export class SolutionsPeopleFiltersDialogComponent {
  private readonly _dialogRef = inject(DialogRef);
  private readonly _router = inject(Router);
  private readonly _activatedRoute = inject(ActivatedRoute);

  close(): void {
    this._dialogRef.close();
  }

  applyFilters(): void {
    this.close();
  }

  removeFilters(): void {
    this._router.navigate([], {
      relativeTo: this._activatedRoute,
      queryParams: {
        category_id: null,
        min_age: null,
        max_age: null,
        trade: null,
        bim_ready: null,
        page: null,
      },
      queryParamsHandling: 'merge',
    });
  }
}
